import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface CratSwapModalPayload {
  data?: null;
  type: ModalType.CratSwap;
  isOpen?: boolean;
}

export const CratSwapModal = React.forwardRef<
  HTMLElement,
  Pick<CratSwapModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="CratSwap V3 (DEX)"
      subtitle="The Native Exchange of the Ecosystem"
      icon={<Icons.CratSwapDark />}
      link={{
        title: 'Start Trading',
        link: {
          href: ECOSYSTEM_LINKS.trading,
          text: ECOSYSTEM_LINKS.trading,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        CratSwap V3 is a decentralized exchange (DEX) built on CratD2C.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It allows users to swap tokens, provide liquidity, and earn yield without going through a centralized exchange.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Everything runs through smart contracts, meaning you stay in control of your funds while trading within the
        CratD2C ecosystem.
      </Typography>
    </ModalSidebar>
  );
});
